import React from 'react';
import { 
  ClipboardList, 
  Code, 
  PenTool, 
  Database, 
  Rocket, 
  Zap, 
  CheckCircle,
  GraduationCap
} from 'lucide-react';

const ShopwareProcess = () => {
  const steps = [
    {
      icon: <ClipboardList className="h-7 w-7 text-blue-600" />,
      title: "1. Anforderungsanalyse",
      description: "Wir analysieren deine Geschäftsprozesse, Zielgruppe und Anforderungen und erarbeiten ein maßgeschneidertes Shopware-Konzept."
    },
    {
      icon: <PenTool className="h-7 w-7 text-blue-600" />,
      title: "2. Design & UX-Konzept",
      description: "Auf Basis deiner CI entwerfen wir ein verkaufsstarkes, nutzerfreundliches Design mit klarem Fokus auf Conversion-Optimierung."
    },
    {
      icon: <Code className="h-7 w-7 text-blue-600" />,
      title: "3. Technische Umsetzung",
      description: "Unsere Entwickler programmieren deinen Shop mit sauberem Code, optimaler Performance und allen benötigten Funktionen."
    },
    {
      icon: <Database className="h-7 w-7 text-blue-600" />,
      title: "4. Datenintegration",
      description: "Wir verbinden deinen Shopware-Shop mit ERP, PIM, CRM und anderen Systemen für nahtlose Prozesse und Datensynchronisation."
    },
    {
      icon: <CheckCircle className="h-7 w-7 text-blue-600" />,
      title: "5. Qualitätssicherung",
      description: "Umfassende Tests auf allen Geräten, Browsern und Betriebssystemen stellen sicher, dass dein Shop einwandfrei funktioniert."
    },
    {
      icon: <Rocket className="h-7 w-7 text-blue-600" />,
      title: "6. Launch & Aktivierung",
      description: "Wir übernehmen den sicheren Launch deines Shops und unterstützen dich bei den ersten Schritten im Live-Betrieb."
    },
    {
      icon: <GraduationCap className="h-7 w-7 text-blue-600" />,
      title: "7. Schulung & Support",
      description: "Nach der Fertigstellung schulen wir dein Team und stehen dir mit Support und regelmäßigen Updates zur Seite."
    },
    {
      icon: <Zap className="h-7 w-7 text-blue-600" />,
      title: "8. Kontinuierliche Optimierung",
      description: "Wir begleiten dich auch nach dem Go-live mit regelmäßigen Analysen und Optimierungen für nachhaltigen Erfolg."
    }
  ];

  return (
    <section id="shopware-process" className="py-16 md:py-24 bg-white">
      <div className="container">
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-100 text-blue-700 text-sm font-semibold px-3 py-1 rounded-full mb-4">
            Transparente Prozesse
          </div>
          
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            So läuft dein Shopware-Projekt mit uns ab
          </h2>
          
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Von der ersten Idee bis zum erfolgreichen Online-Shop: Wir begleiten dich mit einem 
            strukturierten, transparenten Prozess durch alle Phasen deines Shopware-Projekts.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="bg-white border-2 border-gray-100 hover:border-blue-200 rounded-xl p-6 transition-all duration-300 hover:shadow-md">
              <div className="rounded-full bg-blue-100 p-4 w-16 h-16 flex items-center justify-center mb-5">
                {step.icon}
              </div>
              <h3 className="text-xl font-bold mb-3">{step.title}</h3>
              <p className="text-gray-600">{step.description}</p>
            </div>
          ))}
        </div>
        
        <div className="mt-16 bg-blue-50 rounded-xl p-8 md:p-10">
          <div className="flex flex-col md:flex-row gap-8 items-center">
            <div className="w-full md:w-1/3">
              <h3 className="text-2xl font-bold mb-3">Termingerechte Umsetzung garantiert</h3>
              <p className="text-gray-600">
                Wir verstehen, wie wichtig die Einhaltung des Zeitplans ist. Daher garantieren wir 
                termingerechte Umsetzung deines Shopware-Projekts. Sprich uns auf unsere 
                Zeitplan-Garantie an!
              </p>
            </div>
            
            <div className="w-full md:w-2/3 grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="bg-white rounded-lg p-5 text-center">
                <div className="text-3xl font-bold text-blue-700 mb-2">4-8</div>
                <p className="text-sm text-gray-600">Wochen für Standard-Shop</p>
              </div>
              
              <div className="bg-white rounded-lg p-5 text-center">
                <div className="text-3xl font-bold text-blue-700 mb-2">8-12</div>
                <p className="text-sm text-gray-600">Wochen für B2B-Plattform</p>
              </div>
              
              <div className="bg-white rounded-lg p-5 text-center">
                <div className="text-3xl font-bold text-blue-700 mb-2">2-4</div>
                <p className="text-sm text-gray-600">Wochen für Relaunch</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopwareProcess; 